module.exports = __webpack_public_path__ + "img/電気回路_4_9_3.23d7ac6e.png";